@for (recommendation of recommendations; track recommendation) {
  @if (!recommendation.url) {
    <div class="recommendation">
      <div class="thumb-container">
        <div class="thumb" [responsiveBackgroundImage]="recommendation.thumbnail">
          @if (!recommendation.thumbnail) {
            <div class="all-done">
              <img src="/assets/community/recommended-check.svg" alt="Check mark" />
            </div>
          }
        </div>
      </div>
      <div class="details">
        <div class="info">
          <div class="title">{{recommendation.title}}</div>
        </div>
      </div>
    </div>
  }
  @if (recommendation.url) {
    <a href="{{recommendation.url}}" class="recommendation">
      <div class="thumb-container">
        <div class="thumb"
        [responsiveBackgroundImage]="recommendation.thumbnail || '/assets/flag-backdrop.png'"></div>
        @if (recommendation.status) {
          <div class="status">
            {{recommendation.status}}
          </div>
        }
      </div>
      <div class="details">
        <div class="info">
          <div class="title">{{recommendation.title}}</div>
        </div>
        <div class="facts-container">
          <ul class="facts">
            @for (fact of asArray(recommendation.facts); track fact) {
              <li>{{fact}}</li>
            }
          </ul>
        </div>
      </div>
    </a>
  }
}